import React from "react";
import BungalowIcon from "@mui/icons-material/Bungalow";
import ReceiptIcon from "@mui/icons-material/Receipt";
import WalletIcon from "@mui/icons-material/Wallet";
import StorefrontIcon from "@mui/icons-material/Storefront";
import HistoryIcon from "@mui/icons-material/History";
import TableViewIcon from "@mui/icons-material/TableView";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import SendIcon from "@mui/icons-material/Send";
import BarChartIcon from "@mui/icons-material/BarChart";
import PeopleIcon from "@mui/icons-material/People";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import FunctionsIcon from "@mui/icons-material/Functions";
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';
import DvrIcon from '@mui/icons-material/Dvr';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import PixIcon from '@mui/icons-material/Pix';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import PaymentsIcon from '@mui/icons-material/Payments';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import PublicIcon from '@mui/icons-material/Public';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import StackedBarChartIcon from '@mui/icons-material/StackedBarChart';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import QrCodeIcon from '@mui/icons-material/QrCode';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import DonutSmallIcon from '@mui/icons-material/DonutSmall';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import BugReportIcon from '@mui/icons-material/BugReport';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';


type IconTypes =
    'BungalowIcon'
    | 'ReceiptIcon'
    | 'WalletIcon'
    | 'StorefrontIcon'
    | 'HistoryIcon'
    | 'TableViewIcon'
    | 'ManageAccountsIcon'
    | 'SendIcon'
    | 'BarChartIcon'
    | 'PeopleIcon'
    | 'LogoutIcon'
    | 'MenuIcon'
    | 'CompareArrowsIcon'
    | 'TrendingUpIcon'
    | 'FunctionsIcon'
    | 'DeveloperBoardIcon'
    | 'DvrIcon'
    | 'AttachMoneyIcon'
    | 'LocalAtmIcon'
    | 'CreditCardIcon'
    | 'PixIcon'
    | 'MilitaryTechIcon'
    | 'PaymentsIcon'
    | 'AccountBalanceWalletIcon'
    | 'PublicIcon'
    | 'RecentActorsIcon'
    | 'CloudUploadIcon'
    | 'DriveFolderUploadIcon'
    | 'FileUploadIcon'
    | 'UploadFileIcon'
    | 'ProductionQuantityLimitsIcon'
    | 'VisibilityIcon'
    | 'AddShoppingCartIcon'
    | 'StackedBarChartIcon'
    | 'DocumentScannerIcon'
    | 'QrCodeIcon'
    | 'ShowChartIcon'
    | 'DonutSmallIcon'
    | 'AnalyticsIcon'
    | 'BugReportIcon'
    | 'ReceiptLongIcon'
    ;

type IconMapping = {
    [key: string]: React.ElementType; // Mapeia nomes de ícones para componentes React
};

const iconMapping: IconMapping = {
    BungalowIcon: BungalowIcon,
    ReceiptIcon: ReceiptIcon,
    WalletIcon: WalletIcon,
    StorefrontIcon: StorefrontIcon,
    HistoryIcon: HistoryIcon,
    TableViewIcon: TableViewIcon,
    ManageAccountsIcon: ManageAccountsIcon,
    SendIcon: SendIcon,
    BarChartIcon: BarChartIcon,
    PeopleIcon: PeopleIcon,
    LogoutIcon: LogoutIcon,
    MenuIcon: MenuIcon,
    CompareArrowsIcon: CompareArrowsIcon,
    TrendingUpIcon: TrendingUpIcon,
    FunctionsIcon: FunctionsIcon,
    DeveloperBoardIcon: DeveloperBoardIcon,
    DvrIcon: DvrIcon,
    AttachMoneyIcon: AttachMoneyIcon,
    LocalAtmIcon: LocalAtmIcon,
    CreditCardIcon: CreditCardIcon,
    PixIcon: PixIcon,
    MilitaryTechIcon: MilitaryTechIcon,
    PaymentsIcon: PaymentsIcon,
    AccountBalanceWalletIcon: AccountBalanceWalletIcon,
    PublicIcon: PublicIcon,
    RecentActorsIcon: RecentActorsIcon,
    CloudUploadIcon: CloudUploadIcon,
    DriveFolderUploadIcon: DriveFolderUploadIcon,
    FileUploadIcon: FileUploadIcon,
    UploadFileIcon: UploadFileIcon,
    VisibilityIcon: VisibilityIcon,
    AddShoppingCartIcon: AddShoppingCartIcon,
    StackedBarChartIcon: StackedBarChartIcon,
    DocumentScannerIcon: DocumentScannerIcon,
    QrCodeIcon: QrCodeIcon,
    ShowChartIcon: ShowChartIcon,
    DonutSmallIcon: DonutSmallIcon,
    AnalyticsIcon: AnalyticsIcon,
    BugReportIcon: BugReportIcon,
    ReceiptLongIcon: ReceiptLongIcon
};

interface Props {
    iconName: string;
    marginRight?: string | number;
    marginBottom?: string;
    color?: string;
    alignItems?: string;
};

const DynamicIcon: React.FC<Props> = ({
                                          iconName,
                                          marginRight = '5px',
                                          marginBottom = '-5px',
                                          color = '#ffffff',
                                          alignItems = 'baseline'
                                      }) => {
    const IconComponent = iconMapping[iconName];
    return (
        <div>
            {IconComponent && <IconComponent sx={{
                color: color,
                marginRight: marginRight,
                marginBottom: marginBottom,
                alignItem: alignItems
            }}/>}
        </div>
    );
};

export type {IconTypes};
export default DynamicIcon;